import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './redux/reducer';

const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActionPaths: [
                    'payload.onSuccess',
                    'onSuccess',
                    'payload.onFailure',
                    'onFailure',
                ],
            }
        })
});

export type AppStore = typeof store

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = AppStore['dispatch'];

export default store;
